export default "__VITE_ASSET__HVPBv8B9__"